import { StandardEvents } from '@shopify/events';

class GBProductLabels extends HTMLElement {
 connectedCallback() {
  this.section = this.dataset.context === 'card' ? this.closest('product-card') : this.closest('.shopify-section, dialog');
  this.section?.addEventListener(StandardEvents.productSelect, this.onProductSelect);
 }
 disconnectedCallback() {
  this.section?.removeEventListener(StandardEvents.productSelect, this.onProductSelect);
 }
 onProductSelect = (event) => {
  if (!(event.target instanceof Element)) return;
  const card = event.target.closest('product-card');
  if (this.dataset.context === 'product' && card) return;
  if (this.dataset.context === 'card' && card !== this.closest('product-card')) return;
  event.promise.then(({ detail }) => {
   if (!detail?.html) return;
   if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
   const placement = this.dataset.placement || 'overlay';
   const updated = detail.html.querySelector(`gb-product-labels[data-context="product"][data-placement="${placement}"]`) || detail.html.querySelector(`gb-product-labels[data-product-id="${this.dataset.productId}"][data-placement="${placement}"]`);
   if (!updated) return;
   this.replaceChildren(...Array.from(updated.childNodes, node => node.cloneNode(true)));
   this.dataset.productId = updated.dataset.productId;
   this.dataset.variantId = updated.dataset.variantId;
  }).catch(error => {
   if (error?.name !== 'AbortError') console.warn('[GBProductLabels]', error);
  });
 };
}
if (!customElements.get('gb-product-labels')) customElements.define('gb-product-labels', GBProductLabels);

